import { get, isEmpty } from "lodash";
import MASTER_TEST_ID_MAP from "../test.ids.json";

/**
 *
 * @param {string} path
 * @returns {object}
 */

export function useTestIds(path) {
  if (!path || typeof path !== "string") return null;

  const idSource = get(MASTER_TEST_ID_MAP, path, {});

  if (isEmpty(idSource)) {
    console.error(`No test ids found for ${path}.`);
  }

  /**
   *
   * @param {object} source
   * @returns {object}
   */

  function buildTestIds(source) {
    // iterates through the key value pairs of the given source object
    // and appends the component suffix to the path
    return Object.entries(source).reduce((ids, [key, value]) => {
      const testId = `${path}-${value}`;
      return { ...ids, [key]: testId };
    }, {});
  }

  return buildTestIds(idSource);
}
